import React, { useEffect, useState } from "react";
import { Box, styled } from "@mui/system";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import lucy_statements from "../data/lucy_statements";

const CardContentsMobile = styled(CardContent)({
  color: "#F4F4FF",
  padding: "0.5rem",
});

const TopicAnalysisMobile = ({ analysisData }) => {
  const [lucyStatements, setLucyStatements] = useState(lucy_statements);

  useEffect(() => {
    lucy_statements.sort(() => Math.random() - 0.5);
    setLucyStatements(lucy_statements);
  }, []);

  return (
    <CardContentsMobile>
      <h4 style={{ textAlign: "center", marginTop: "4%" }}>
        Personalized Analysis
      </h4>
      <h6 style={{ textAlign: "center", marginBottom: "6%" }}>
        (by Lucy, The Placement Bot 🤖)
      </h6>
      {analysisData.map((item, index) => {
        return (
          <Accordion
            style={{
              marginBottom: "1%",
              backgroundColor: index % 2 ? "#6F63E6" : "#E7E6FE",
              color: index % 2 ? "white" : "black",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div
                style={{
                  marginRight: "auto",
                }}
              >
                <h6>{item.subject} 📚</h6>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <Typography style={{ fontSize: "14px" }}>
                    {lucyStatements[index].replaceAll(
                      "<Subject-Name>",
                      item.subject
                    )}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={4} lg={4}>
                  <Card
                    sx={{
                      boxShadow: 2,
                      backgroundColor: index % 2 ? "#E7E6FE" : "#6F63E6",
                    }}
                  >
                    <CardContentsMobile
                      style={{ color: index % 2 ? "black" : "white" }}
                    >
                      <table
                        style={{
                          width: "100%",
                          textAlign: "center",
                          tableLayout: "fixed",
                        }}
                      >
                        <thead>
                          <tr>
                            <th
                              colSpan="2"
                              style={{
                                padding: "2%",
                                fontWeight: "bold",
                                fontSize: "1.1rem",
                              }}
                            >
                              Weak Topics
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {item.weak_topic.map((item2) => {
                              return (
                                <td
                                  key={item2.topic}
                                  style={{
                                    padding: "2%",
                                  }}
                                >
                                  {item2.topic}
                                </td>
                              );
                            })}
                          </tr>
                        </tbody>
                      </table>
                    </CardContentsMobile>
                  </Card>
                </Grid>

                <Grid item xs={12} md={8} lg={8}>
                  <Card
                    sx={{
                      boxShadow: 2,
                      backgroundColor: index % 2 ? "#E7E6FE" : "#6F63E6",
                    }}
                  >
                    <CardContentsMobile
                      style={{ color: index % 2 ? "black" : "white" }}
                    >
                      <h6
                        style={{
                          textAlign: "center",
                          marginBottom: "2%",
                          padding: "2%",
                          fontWeight: "bold",
                          fontSize: "1.1rem",
                        }}
                      >
                        Handpicked Resources!
                      </h6>
                      {item.weak_topic.map((item2) => {
                        return (
                          <Accordion
                            style={{
                              marginBottom: "1%",
                              backgroundColor:
                                index % 2 ? "#6F63E6" : "#E7E6FE",
                              color: index % 2 ? "white" : "black",
                            }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <div style={{ marginRight: "auto" }}>
                                <h6>{item2.topic}</h6>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails
                              style={{
                                marginLeft: "5%",
                              }}
                            >
                              <ul>
                                {item2.resources.map((resource) => {
                                  return (
                                    <li key={resource.title}>
                                      <a
                                        href={resource.link}
                                        target="_blank"
                                        style={{
                                          color: index % 2 ? "white" : "black",
                                          textDecoration: "underline 1px",
                                          textUnderlineOffset: "25%",
                                        }}
                                      >
                                        {resource.title}
                                      </a>
                                    </li>
                                  );
                                })}
                              </ul>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })}
                    </CardContentsMobile>
                  </Card>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </CardContentsMobile>
  );
};

export default TopicAnalysisMobile;
